import React from 'react'
import { Chip, Grid, makeStyles, Paper } from '@material-ui/core'

import { ProductList, Typography } from 'src/modules/ui'
import { generateOrderNumber } from 'src/utils'
import theme from '../theme'
import { titleCase } from 'title-case'

const useStyles = makeStyles(theme => ({
  orderContainer: {
    marginTop: theme.spacing(2),
  },
  productTable: {
    borderRadius: theme.shape.borderRadius,
    width: '100%',
  },
}))

const InvoiceOrders = ({
  orders,
  lineItems,
  isDisputed = false,
  drilledDisputeNotes = {},
}) => {
  const classes = useStyles()

  const products = lineItems.map(lineItem => ({
    available: true,
    // Agreement product will be blank if it is no longer available
    id: lineItem.id,
    orderId: lineItem.orderId,
    avEquivalentUnitSize: lineItem.productAvEquivalentUnitSize,
    code: lineItem.productCode,
    excludeFromOrder: lineItem.excludeFromOrder,
    name: lineItem.productName,
    price: lineItem.productPrice,
    unit: lineItem.productUnit,
    quantity: lineItem.quantity,
    totalSizeSent: lineItem.totalSizeSent,
    updatedProductName: lineItem.updatedProductName,
    updatedProductPrice: lineItem.updatedProductPrice,
    updatedQuantity: lineItem.updatedQuantity,
    updatedProductUnit: lineItem.updatedProductUnit,
    variablePrice: lineItem.productVariablePrice,
    variablePriceUnit: lineItem.productVariablePriceUnit,
    vatRate: lineItem.productVatRate,
    lineItemDisputeReason: lineItem.disputeReason,
  }))

  const selectedOrders = orders.map(order => ({
    ...order,
    products: products.filter(({ orderId }) => orderId === order.id),
  }))

  return (
    <>
      {selectedOrders.map(({ products, ...order }) => (
        <div key={order.id} className={classes.orderContainer}>
          <div style={{ display: 'flex' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" color="lightGreen">
                  Order {generateOrderNumber(order)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} justifyContent="flex-end">
                <Chip
                  label={titleCase(order.status.replace(/_/g, ' '))}
                  style={{ marginBottom: theme.spacing(2) }}
                  size="small"
                />
              </Grid>
            </Grid>
          </div>
          {order.notes ? (
            <Paper
              elevation={0}
              style={{
                padding: '1rem',
                marginTop: '1rem',
                marginBottom: '1rem',
              }}
            >
              <Typography
                color="lightGreen"
                variant="h5"
                style={{ marginTop: 10 }}
              >
                Order Notes
              </Typography>
              <Typography variant="body2" style={{ marginTop: 5 }}>
                {order.notes}
              </Typography>
            </Paper>
          ) : null}
          <ProductList
            noCategories
            hideHeader
            products={products}
            showDescription={false}
            showPhoto={false}
            showQuantity
            showSubtotal={true}
            tableClassName={classes.productTable}
            showDisputed={isDisputed}
            drilledDisputeNotes={drilledDisputeNotes}
          />
        </div>
      ))}
    </>
  )
}

export default InvoiceOrders
